import { cx } from '@emotion/css';

import { badgeClassName } from './styles';

interface Props {
  className?: string;
  label: string;
}

const Badge = ({ className, label }: Props) => {
  return <div className={cx(badgeClassName, className)}>{label}</div>;
};

Badge.displayName = 'Badge';

export default Badge;
